import { useAuth } from '@clerk/clerk-react'
import { storage } from '@/helpers'
import { useEffect, useState } from 'react'
import { jwtDecode } from 'jwt-decode'
import Loading from '@/components/Loading'
import { useCurrentUser, CURRENT_USER_QUERY_KEY } from '@/hooks/useCurrentUser'
import { useQueryClient } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'
import {setLoggerUser} from "@/logger/logger";

interface ClerkJWTPayload {
  authToken: string
  [key: string]: unknown
}

let authPromise: Promise<void> | undefined

export const AuthIntermediator = ({ children }: PropsWithChildren) => {
  const { getToken, isSignedIn, isLoaded } = useAuth()
  const queryClient = useQueryClient()
  const [tokenReady, setTokenReady] = useState(() => !!storage.getItem('token'))
  const { data, isSuccess } = useCurrentUser()

  useEffect(() => {
    if (!isLoaded || !isSignedIn || authPromise || tokenReady) return

    authPromise = getToken().then((clerkToken) => {
      if (!clerkToken) return
      const decoded = jwtDecode<ClerkJWTPayload>(clerkToken)
      storage.setItem('token', decoded.authToken)
      setTokenReady(true)
    })
  }, [isLoaded, isSignedIn, tokenReady])

  // Clear the promise and query when signed out
  useEffect(() => {
    if (!isSignedIn) {
      authPromise = undefined
      queryClient.removeQueries({ queryKey: CURRENT_USER_QUERY_KEY })
    }
  }, [isSignedIn, queryClient])

  useEffect(() => {
    setLoggerUser(data?.user)
  }, [data]);

  // Wait for token to be ready and query to succeed
  const ready = isLoaded && isSignedIn && tokenReady && isSuccess && !!data?.user

  return ready ? <>{children}</> : <Loading message="Loading..." />
}
